<template>
  <div id="showPic">
    <div class="show-pic">
      <div class="pic-left">
        <div class="show-pic-head">
          <div class="show-pic-name">
            <span>Material</span>/物资</div>
          <div class="bottom-bodder"></div>
        </div>
        <div class="pic-box">
          <img v-lazy="picArr[0]">
          <div class="pic-describe">
            <div>
              易比得适用于生产原料、办公用品、IT设备等各种物资的采购
              <!-- <a href="javascript:void(0)">[详细]</a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="pic-middle" style="padding-top:35px;">
        <div class="pic-box">
          <img v-lazy="picArr[1]">
          <div class="pic-describe" style="top:0">
            <div>
              客户可以通过易比得完成各种工程项目的招标或询价，实现采购电子化
              <!-- <a href="javascript:void(0)">[详细]</a> -->
            </div>
          </div>
          <div class="show-pic-head" style="position: absolute;left:48px;bottom:0;">
            <div class="show-pic-name">
              <span>Project</span>/工程</div>
            <div class="bottom-bodder" style="position: absolute;bottom:0;left:50%;"></div>
          </div>
        </div>
      </div>
      <div class="pic-right">
        <div class="show-pic-head" style="position: relative;">
          <div class="show-pic-name">服务/
            <span>Service</span>
          </div>
          <div class="bottom-bodder" style="position: absolute;bottom:0;left:100%"></div>
        </div>
        <div class="pic-box">
          <img v-lazy="picArr[2]">
          <div class="pic-describe">
            <div>
              人力服务、开发服务、物业服务、安装服务等等，所有的服务项目均可以通过易比得平台实现采购方和供应商的对接
              <!-- <a href="javascript:void(0)">[详细]</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'showPic',
  data() {
    return {
      picArr: [
        require('@/assets/img/show-pic/wuzi.jpg'),
        require('@/assets/img/show-pic/project.jpg'),
        require('@/assets/img/show-pic/service.jpg')
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 物资工程服务动画效果
      $('.show-pic .pic-left').mouseenter(function() {
        $(this)
          .find('.pic-describe')
          .stop()
          .slideDown('slow');
        $(this)
          .find('.bottom-bodder')
          .stop()
          .animate({ width: 274 }, function() {
            $(this)
              .prev()
              .css('visibility', 'visible');
          });
      });
      $('.show-pic .pic-left').mouseleave(function() {
        $(this)
          .find('.show-pic-name')
          .css('visibility', 'hidden');
        $(this)
          .find('.pic-describe')
          .stop()
          .slideUp('slow');
        $(this)
          .find('.bottom-bodder')
          .stop()
          .animate({ width: 0 });
      });

      $('.show-pic .pic-middle').mouseenter(function() {
        $(this)
          .find('.pic-describe')
          .stop()
          .slideDown('slow');
        $(this)
          .find('.bottom-bodder')
          .stop()
          .animate({ width: 274, left: '0' }, function() {
            $(this)
              .prev()
              .css('visibility', 'visible');
          });
      });
      $('.show-pic .pic-middle').mouseleave(function() {
        $(this)
          .find('.show-pic-name')
          .css('visibility', 'hidden');
        $(this)
          .find('.pic-describe')
          .stop()
          .slideUp('slow');
        $(this)
          .find('.bottom-bodder')
          .stop()
          .animate({ width: 0, left: '50%' });
      });

      $('.show-pic .pic-right').mouseenter(function() {
        $(this)
          .find('.pic-describe')
          .stop()
          .slideDown('slow');
        $(this)
          .find('.bottom-bodder')
          .stop()
          .animate({ width: 274, left: '0' }, function() {
            $(this)
              .prev()
              .css('visibility', 'visible');
          });
      });
      $('.show-pic .pic-right').mouseleave(function() {
        $(this)
          .find('.show-pic-name')
          .css('visibility', 'hidden');
        $(this)
          .find('.pic-describe')
          .stop()
          .slideUp('slow');
        $(this)
          .find('.bottom-bodder')
          .stop()
          .animate({ width: 0, left: '100%' });
      });
    }
  }
};
</script>
<style lang="less" scoped>
#showPic {
  .show-pic {
    height: 388px;
    margin-bottom: 135px;
  }
  .show-pic .pic-left,
  .show-pic .pic-middle,
  .show-pic .pic-right {
    width: 373px;
    height: 388px;
    float: left;
  }
  .show-pic .pic-left {
    margin-left: 100px;
  }
  .show-pic .pic-middle {
    margin: 0 27px;
  }
  .show-pic .show-pic-head {
    width: 274px;
    height: 35px;
  }
  .show-pic .show-pic-head .show-pic-name {
    visibility: hidden;
    width: 274px;
    text-align: right;
    font-size: 24px;
    font-family: 'Microsoft YaHei';
    font-weight: bold;
    line-height: 26px;
    color: #686868;
  }
  .show-pic .show-pic-head .bottom-bodder {
    width: 0px;
    border-bottom: 5px solid #2a85cb;
  }
  .show-pic .show-pic-head span {
    font-size: 14px;
    font-weight: normal;
  }
  .show-pic .pic-box {
    height: 350px;
    width: 370px;
    border: 1px solid #f5f5f5;
    border-top: 0;
    position: relative;
  }
  .show-pic .pic-box img {
    height: 350px;
    width: 370px;
  }
  .show-pic .pic-describe {
    height: 106px;
    width: 370px;
    background-color: #000;
    background-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    bottom: 0;
    display: none;
  }
  .show-pic .pic-describe div {
    width: 306px;
    margin: auto;
    color: #fff;
    line-height: 18px;
    padding-top: 29px;
    font-size: 12px;
  }
  .show-pic .pic-describe a {
    color: #2a85cb;
  }
  .show-pic .pic-middle .show-pic-name {
    text-align: center;
  }
  .show-pic .pic-middle .bottom-bodder {
    border-bottom: 5px solid #fb5b3b;
  }
  .show-pic .pic-middle .pic-describe a {
    color: #fb5b3b;
  }
  .show-pic .pic-right .show-pic-head {
    margin-left: 97px;
  }
  .show-pic .pic-right .show-pic-head .show-pic-name {
    text-align: left;
  }
  .show-pic .pic-right .show-pic-head .bottom-bodder {
    border-bottom: 5px solid #fbb03b;
  }
  .show-pic .pic-right .pic-describe a {
    color: #fbb03b;
  }
}
</style>
